import { type ColumnDef, createColumnHelper } from '@tanstack/react-table';
import { tableRowSelectColumn } from 'shared/components';
import { HeapNameItem } from './heap-name-item';
import type { HeapsTableData } from './types';

const columnHelper = createColumnHelper<HeapsTableData>();

export const heapsClusterListColumnData = ({
  handleRenameHeap,
  editingHeapId,
  setEditingHeapId,
}): ColumnDef<HeapsTableData, any>[] => {
  return [
    tableRowSelectColumn({
      headerText: 'S.No.',
      showCheckboxIndex: true,
    }),
    columnHelper.accessor('heapName', {
      enableResizing: false,
      maxSize: 500,
      header: () => <div className="header-cell heap-name">Heap Name</div>,
      cell: (info) => (
        <HeapNameItem
          heapName={info.getValue()}
          heapId={info.cell.row.id}
          message={info.row.original.message}
          messageLevel={info.row.original.messageLevel}
          handleRenameHeap={handleRenameHeap}
          editingHeapId={editingHeapId}
          setEditingHeapId={setEditingHeapId}
        />
      ),
    }),
    columnHelper.accessor('volumeCut', {
      size: 500,
      header: () => (
        <div className="header-cell volume">
          <div>Volume Cut</div>
          <div className="header-cell__unit">
            (m<sup>3</sup>)
          </div>
        </div>
      ),
      cell: (info) => (
        <div className="value-cell volume-value">{info.getValue()}</div>
      ),
    }),
    columnHelper.accessor('volumeFill', {
      size: 500,
      header: () => (
        <div className="header-cell volume">
          <div>Volume Fill</div>
          <div className="header-cell__unit">
            (m<sup>3</sup>)
          </div>
        </div>
      ),
      cell: (info) => (
        <div className="value-cell volume-value">{info.getValue()}</div>
      ),
    }),
    columnHelper.accessor('volumeNet', {
      size: 500,
      header: () => (
        <div className="header-cell volume">
          <div>Volume Net</div>
          <div className="header-cell__unit">
            (m<sup>3</sup>)
          </div>
        </div>
      ),
      cell: (info) => (
        <div className="value-cell volume-value">{info.getValue()}</div>
      ),
    }),
    columnHelper.accessor('weightCut', {
      size: 500,
      header: () => (
        <div className="header-cell weight">
          <div>Weight Cut</div>
          <div className="header-cell__unit">(tonnes)</div>
        </div>
      ),
      cell: (info) => (
        <div className="value-cell weight-value">{info.getValue()}</div>
      ),
    }),
    columnHelper.accessor('weightFill', {
      size: 500,
      header: () => (
        <div className="header-cell weight">
          <div>Weight Fill</div>
          <div className="header-cell__unit">(tonnes)</div>
        </div>
      ),
      cell: (info) => (
        <div className="value-cell weight-value">{info.getValue()}</div>
      ),
    }),
    columnHelper.accessor('weightNet', {
      size: 500,
      header: () => (
        <div className="header-cell weight">
          <div>Weight Net</div>
          <div className="header-cell__unit">(tonnes)</div>
        </div>
      ),
      cell: (info) => (
        <div className="value-cell weight-value">{info.getValue()}</div>
      ),
    }),
  ];
};
